/**
 * French number formats of the design system: `1 284`, `12,5 %`, `3,25`.
 * Groups come from Intl (fr-FR); the percent sign is always preceded by a narrow
 * no-break space (U+202F), so a value never wraps in a table cell.
 */

const EMPTY = "—";

function isMissing(value: number | null | undefined): value is null | undefined {
    return value === null || value === undefined || Number.isNaN(value);
}

/** Grouped integer or number: 1284 → "1 284". */
export function formatNumber(value: number | null | undefined, maximumFractionDigits = 0): string {
    if (isMissing(value)) return EMPTY;
    return value.toLocaleString("fr-FR", { maximumFractionDigits });
}

/** Fixed decimals with a decimal comma: (3.2, 2) → "3,20". */
export function formatDecimal(value: number | null | undefined, decimals = 2): string {
    if (isMissing(value)) return EMPTY;
    return value.toLocaleString("fr-FR", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

/**
 * A value already expressed in percent (0-100): 12.5 → "12,5 %". `minimumFractionDigits`
 * keeps a fixed precision in table columns.
 */
export function formatPercent(value: number | null | undefined, maximumFractionDigits = 1, minimumFractionDigits = 0): string {
    if (isMissing(value)) return EMPTY;
    return `${value.toLocaleString("fr-FR", { minimumFractionDigits, maximumFractionDigits })}\u202f%`;
}
